var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdl-grid mdl-grid--no-spacing line-gauge-container"},[_c('div',{staticClass:"mdl-cell mdl-cell--middle lg-box"},[_c('LineGauge',{attrs:{"value":_vm.value,"bg-color":_vm.bgColor}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }